/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import React from 'react'
import { Container, Label, Value } from './styles'

interface ModalInformationProps {
  label: string
  value?: string | number
}

export const ModalInformations: React.FC<ModalInformationProps> = ({
  label,
  value
}: ModalInformationProps): JSX.Element => {
  return (
    <Container>
      <Label>{`${label}: `}</Label>
      <Value>{value || 'Não informado'}</Value>
    </Container>
  )
}
